/**
 * application.js
 *
 * This file compiles to /public/assets/js/application.js
 * You should use it to import all your js components
 */

window.Popper = require('popper.js').default;
window.$ = window.jQuery = require('jquery');

require('bootstrap');

import PhotoSwipeMounter from 'jquery.photoswipe';
PhotoSwipeMounter(jQuery);

window.imagesLoaded = require('imagesloaded');
window.Masonry = require('masonry-layout');

import ScrollReveal from 'scrollreveal';
window.sr = ScrollReveal();

window.Instafeed = require('instafeed.js');

window.slick = require('slick-carousel');

window.Headroom = require('headroom.js');

require('./scripts');


// WEBPACK FOOTER //
// ./src/js/application.js